import React from 'react'

import WhiteHero from 'components/shared/WhiteHero'
import IconLinkList from 'components/shared/IconLinkList'

import RichText from 'components/typo/RichText'
import css from './styles.module.scss'

const CommunityWhiteHero = ({ whiteHero, socialMediaIntro, socialMedia }) => {
  return (
    <div className="container">
      <WhiteHero {...whiteHero}>
        {socialMedia && (
          <div className={css.channels}>
            {socialMediaIntro && (
              <div className={css.channelsTitle}>
                <RichText text={socialMediaIntro} />
              </div>
            )}
            <IconLinkList
              className={css.channelsList}
              links={socialMedia}
              big
            />
          </div>
        )}
      </WhiteHero>
    </div>
  )
}

CommunityWhiteHero.defaultProps = {}

export default CommunityWhiteHero
